import { useInfiniteQuery } from "@tanstack/react-query";
import { getLeadTrackActivity } from "../api";
import { LeadTrackActivityType } from "../dtos";

export const LEAD_TRACK_ACTIVITY_QUERY_KEY = "leadTrackActivity";

interface UseLeadTrackActivityOptions {
  trackUId: string;
  limit?: number;
  direction?: "asc" | "desc";
  type?: LeadTrackActivityType[];
  enabled?: boolean;
}

export const useLeadTrackActivity = ({
  trackUId,
  limit = 20,
  direction = "desc",
  type,
  enabled = true,
}: UseLeadTrackActivityOptions) => {
  return useInfiniteQuery({
    queryKey: [LEAD_TRACK_ACTIVITY_QUERY_KEY, trackUId, limit, direction, type],
    queryFn: async ({ pageParam }) => {
      const response = await getLeadTrackActivity({
        trackUId,
        limit,
        cursor: pageParam as string | undefined,
        direction,
        type,
      });
      return response.data;
    },
    getNextPageParam: (lastPage) => {
      return lastPage?.hasNext ? lastPage.nextCursor : undefined;
    },
    enabled: enabled && !!trackUId,
    staleTime: 10000, // 10 seconds - activity updates frequently
  });
};

export default useLeadTrackActivity;
